import Util from "@/helper/Utility.js";

export const PointStore = {
    state: () => ({
        point: 0,
        formattedPoint: 0,
        lastUpdate: 0
    }),
    mutations: {
        setPoint: function(state, updated_points) {
            if (updated_points) {
                state.point = updated_points.points;
                state.formattedPoint = Util.formatNum(updated_points.points);
                state.lastUpdate = updated_points.time;
            }
        }
    },
    getters: {
        getPoint: function(state) {
            return state.point;
        },
        getFormatted: function (state) {
            return state.formattedPoint;
        },
        getLastUpdate: function (state) {
            return state.lastUpdate;
        }
    },
    actions: {
        setPoint: function(context, updated_points) {
            context.commit('setPoint', updated_points);
        }
    }
};
